import React, { useState, useEffect } from 'react';
import { MAPI_URL } from '../data/serverStore';

export default function EmailAgentSetup({ toast }) {
  const [status, setStatus] = useState('checking'); // checking | online | offline

  useEffect(() => {
    checkAgent();
    const t = setInterval(checkAgent, 5000);
    return () => clearInterval(t);
  }, []);

  const checkAgent = () => {
    fetch(`${MAPI_URL}/health`, { signal: AbortSignal.timeout(2000) })
      .then(r => r.ok ? setStatus('online') : setStatus('offline'))
      .catch(() => setStatus('offline'));
  };

  const downloadAgent = () => {
    window.open('https://lims.dieselfuellab.com/email-agent/sterling-email-agent.zip', '_blank');
  };

  return (
    <div className="content" style={{maxWidth:700,margin:'0 auto'}}>

      {/* Status banner */}
      <div style={{
        background: status==='online' ? '#e8f5e9' : status==='offline' ? '#fff3e0' : '#f5f5f5',
        border: `1px solid ${status==='online'?'#81c784':status==='offline'?'#ffb74d':'#ddd'}`,
        borderRadius:8, padding:'14px 20px', marginBottom:20,
        display:'flex', alignItems:'center', gap:12,
      }}>
        <div style={{
          width:14, height:14, borderRadius:'50%', flexShrink:0,
          background: status==='online'?'#4caf50':status==='offline'?'#ff9800':'#9e9e9e',
          boxShadow: status==='online'?'0 0 6px #4caf50':undefined,
        }}/>
        <div>
          <div style={{fontWeight:700, fontSize:13,
            color: status==='online'?'#2e7d32':status==='offline'?'#e65100':'#555'}}>
            {status==='online' ? '✅ Email Agent is running on this computer' :
             status==='offline' ? '⚠️ Email Agent is not running on this computer' :
             '🔄 Checking email agent status...'}
          </div>
          <div style={{fontSize:11, color:'#666', marginTop:2}}>
            {status==='online'
              ? 'Outlook PDF emails are enabled. You can send reports from the Reports screen.'
              : 'Install the email agent to enable Outlook PDF email on this computer.'}
          </div>
        </div>
        <button onClick={checkAgent}
          style={{marginLeft:'auto',background:'none',border:'1px solid #ccc',
            borderRadius:4,padding:'4px 10px',cursor:'pointer',fontSize:11,color:'#555'}}>
          ↺ Refresh
        </button>
      </div>

      {/* Title */}
      <div style={{marginBottom:20}}>
        <h2 style={{fontSize:18,fontWeight:700,color:'#1e3060',marginBottom:6}}>
          📧 Sterling Email Agent
        </h2>
        <p style={{fontSize:12,color:'#555',lineHeight:1.6}}>
          The Email Agent is a small background program that runs silently on your Windows PC.
          It enables the LIMS to open Outlook and attach PDF reports automatically when you click
          "Send Email" in the Reports screen.
        </p>
      </div>

      {/* Download box */}
      <div style={{background:'#f0f4ff',border:'1px solid #c5d0e8',borderRadius:8,
        padding:20,marginBottom:20,textAlign:'center'}}>
        <div style={{fontSize:32,marginBottom:8}}>⬇️</div>
        <div style={{fontSize:15,fontWeight:700,color:'#1e3060',marginBottom:4}}>
          Sterling Email Agent
        </div>
        <div style={{fontSize:11,color:'#666',marginBottom:16}}>
          Windows only · ~2MB · Installs silently · Auto-starts on login
        </div>
        <a href="/email-agent/sterling-email-agent.zip"
          style={{display:'inline-block',background:'#1e3060',color:'white',
            padding:'10px 28px',borderRadius:6,fontWeight:700,fontSize:13,
            textDecoration:'none',cursor:'pointer'}}>
          ⬇️ Download sterling-email-agent.zip
        </a>
      </div>

      {/* Installation steps */}
      <div style={{background:'white',border:'1px solid #e0e4ec',borderRadius:8,padding:20,marginBottom:20}}>
        <div style={{fontWeight:700,fontSize:13,color:'#1e3060',marginBottom:14}}>
          📋 Installation Steps
        </div>
        {[
          ['1', 'Download', 'Click the download button above and save the zip file'],
          ['2', 'Extract', 'Right-click the zip file → Extract All'],
          ['3', 'Run Installer', 'Double-click install.bat — it will automatically install everything including Node.js if needed'],
          ['4', 'Done', 'The agent installs silently and starts automatically. This page will show ✅ when ready'],
        ].map(([num, title, desc]) => (
          <div key={num} style={{display:'flex',gap:12,marginBottom:12,alignItems:'flex-start'}}>
            <div style={{width:26,height:26,borderRadius:'50%',background:'#1e3060',
              color:'white',display:'flex',alignItems:'center',justifyContent:'center',
              fontSize:12,fontWeight:700,flexShrink:0}}>
              {num}
            </div>
            <div>
              <div style={{fontWeight:600,fontSize:12,color:'#1e3060'}}>{title}</div>
              <div style={{fontSize:11,color:'#555',marginTop:1}}>{desc}</div>
            </div>
          </div>
        ))}
      </div>

      {/* FAQ */}
      <div style={{background:'white',border:'1px solid #e0e4ec',borderRadius:8,padding:20}}>
        <div style={{fontWeight:700,fontSize:13,color:'#1e3060',marginBottom:14}}>❓ FAQ</div>
        {[
          ['Does it need to be installed on every computer?',
           'Yes — only on computers where you want to send emails via Outlook. Other computers can still use the LIMS normally for entering data, viewing reports, etc.'],
          ['Does it store any data?',
           'No — zero data storage. It only receives a print request, generates a PDF, and opens Outlook. All lab data stays on the server.'],
          ['How do I know it\'s running?',
           'This page shows a green ✅ status when the agent is active. It also appears as a node.exe process in Task Manager.'],
          ['What if I restart my computer?',
           'The agent auto-starts on every Windows login — no manual action needed.'],
          ['How do I uninstall it?',
           'Run uninstall.bat from the extracted zip folder. It removes everything cleanly.'],
        ].map(([q, a]) => (
          <div key={q} style={{marginBottom:14,paddingBottom:14,borderBottom:'1px solid #f0f2f8'}}>
            <div style={{fontWeight:600,fontSize:12,color:'#333',marginBottom:3}}>Q: {q}</div>
            <div style={{fontSize:11,color:'#555',lineHeight:1.6}}>A: {a}</div>
          </div>
        ))}
      </div>

    </div>
  );
}
